var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetpointOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17001_5880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.42596 6.67282L5.96149 10.2084M5.96149 10.2084L2.42596 13.7439M5.96149 10.2084L0.833323 10.2084M17.1574 13.7439L13.6218 10.2084M13.6218 10.2084L17.1574 6.67282M13.6218 10.2084L19.1667 10.2084",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3272 2.84268L9.79167 6.37821M9.79167 6.37821L6.25614 2.84268M9.79167 6.37821L9.79167 0.833374M6.25614 17.5741L9.79167 14.0385M9.79167 14.0385L13.3272 17.5741M9.79167 14.0385L9.79167 19.1667",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.80215,
    cy: 10.2084,
    r: 1.46576,
    transform: "rotate(45 9.80215 10.2084)",
    fill: "#B8C5CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17001_5880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetpointOptimization);
export default __webpack_public_path__ + "static/media/setpoint-optimization.b47e9c7bb2883fdb42d78db924733d9e.svg";
export { ForwardRef as ReactComponent };